import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { BottomSheetDownloadOptionsComponent } from './report-render/report-exportation/bottom-sheet-download-options/bottom-sheet-download-options.component';
import { ReportPageSizeInfoComponent } from './report-render/report-page-size-info/report-page-size-info.component';
import { ReportFooterComponent } from './report-render/report-footer/report-footer.component';
import { ReportViewComponent } from './report-view/report-view.component';
import { ReportRenderComponent } from './report-render/report-render.component';
import { ReportRowComponent } from './report-render/report-row/report-row.component';
import { ReportHeaderComponent } from './report-render/report-header/report-header.component';
import { ReportSettingsComponent } from './report-settings/report-settings.component';
import { SendEmailDialogComponent } from './report-render/report-exportation/send-email-dialog/send-email-dialog.component';
import { ReportFormViewComponent } from './report-form-view/report-form-view.component';
import { RteFileUploadModule } from 'rte-library';
import { UploadedValuesConfirmDialogComponent } from './report-form-view/uploaded-values-confirm-dialog/uploaded-values-confirm-dialog.component';
import { ReportErrorExportDialogComponent } from './report-render/report-error-export-dialog/report-error-export-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ReportExportationSettingsDialogComponent } from './report-render/report-exportation/report-exportation-settings-dialog/report-exportation-settings-dialog.component';

@NgModule({
  declarations: [
    ReportViewComponent,
    ReportFormViewComponent,
    ReportRenderComponent,
    ReportRowComponent,
    ReportHeaderComponent,
    ReportSettingsComponent,
    ReportPageSizeInfoComponent,
    ReportFooterComponent,
    BottomSheetDownloadOptionsComponent,
    SendEmailDialogComponent,
    UploadedValuesConfirmDialogComponent,
    ReportErrorExportDialogComponent,
    ReportExportationSettingsDialogComponent,
  ],
  exports: [
    ReportViewComponent,
    ReportRenderComponent
  ],
  entryComponents: [
    ReportRenderComponent,
    UploadedValuesConfirmDialogComponent,
    ReportExportationSettingsDialogComponent
  ],
  imports: [
    CommonModule,
    RteFileUploadModule,
    SharedModule.forRoot(),
    ScrollingModule
  ],
})
export class ReportViewModule { }
